import React, { useEffect, useMemo, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { useNavigate } from "react-router-dom";
import withRouter from "../../../components/Common/withRouter";
import { withTranslation } from "react-i18next";

import GlobalLoader from "../../../components/Common/GlobalLoader";
import TableContainerWarehouseRx from "../../../components/Common/TableContainerWarehouseRx";

import { getLoans } from "../../../slice/thunks";

const GetLoans = (props) => {
  const dispatch = useDispatch();
  const history = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [pageSize] = useState(10);

  const selectLayoutState = (state) => state.Settings;
  const OutputsProperties = createSelector(selectLayoutState, (outputs) => ({
    loans: outputs.loans,
    error: outputs.error,
  }));

  const { loans, error } = useSelector(OutputsProperties);

  const items = loans?.items || [];
  const tableTotal = loans?.total_items || items.length;
  const tableTotalPage = loans?.total_page || 1;

  const loadLoans = useCallback(
    (page = 1, term = "") => {
      setIsLoading(true);
      dispatch(getLoans({ page, size: pageSize, term }))
        .then(() => setIsLoading(false))
        .catch(() => setIsLoading(false));
      setCurrentPage(page);
      setSearchTerm(term);
    },
    [dispatch, pageSize]
  );

  useEffect(() => {
    loadLoans(currentPage, searchTerm);
  }, [loadLoans, currentPage, searchTerm]);

  const columns = useMemo(
    () => [
      {
        header: props.t("employee_name"),
        accessorKey: "fullName",
        enableColumnFilter: false,
      },
      {
        header: props.t("salary"),
        accessorKey: "salary",
        cell: (info) => Number(info.getValue()).toLocaleString(),
        enableColumnFilter: false,
      },
      {
        header: props.t("monthly_payment"),
        accessorKey: "amountPerMonth",
        cell: (info) => Number(info.getValue()).toLocaleString(),
        enableColumnFilter: false,
      },
      {
        header: props.t("balance"),
        accessorKey: "amountBalance",
        cell: (info) => Number(info.getValue()).toLocaleString(),
        enableColumnFilter: false,
      },
      {
        header: props.t("remaining_months"),
        accessorKey: "numberMonthBalance",
        enableColumnFilter: false,
      },
      {
        header: props.t("Actions"),
        accessorKey: "actions",
        enableColumnFilter: false,
        cell: ({ row }) => (
          <div className="d-flex gap-2">
            {/* Historique des prêts */}
            <button
              onClick={() =>
                history(`/payroll/loans/${row.original.loanId}/history`)
              }
              style={{ border: "none", background: "transparent", cursor: "pointer" }}
              title={props.t("view_history")}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#0d6efd" viewBox="0 0 24 24">
                <path d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12a5 5 0 1 1 0-10 5 5 0 0 1 0 10zm0-8a3 3 0 1 0 0 6 3 3 0 0 0 0-6z" />
              </svg>
            </button>

            {/* Assigner un nouveau crédit */}
            <button
              onClick={() => {
                const nameSlug = encodeURIComponent(row.original.fullName);
                history(`/payroll/loans/${row.original.employeeId}/assign/${nameSlug}`);
              }}
              style={{ border: "none", background: "transparent", cursor: "pointer" }}
              title={props.t("assign_new_loan")}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="green" viewBox="0 0 24 24">
                <path d="M19 11h-6V5h-2v6H5v2h6v6h2v-6h6z" />
              </svg>
            </button>
          </div>
        ),
      },
    ],
    [props.t, history]
  );

  return (
    <div className="patients-list-content">
      <div className="patients-list px-2 pb-5">
        <div className="container-fluid">
          <div className="heading-parent-sec">
            <div className="heading-child-one-sec pt-4">
              <h6>{props.t("loan_management")}</h6>
            </div>
          </div>

          <div className="card border-0 row p-2">
            {isLoading ? (
              <GlobalLoader />
            ) : error ? (
              <div className="alert alert-danger mt-2">{String(error)}</div>
            ) : (
              <TableContainerWarehouseRx
                columns={columns}
                data={items}
                tablePage={currentPage}
                tableTotal={tableTotal}
                tableTotalPage={tableTotalPage}
                onNextPage={(page) => loadLoans(page, searchTerm)}
                isGlobalFilter={true}
                onSearch={(term) => loadLoans(1, term)}
                SearchPlaceholder={props.t("search_employee")}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(withTranslation()(GetLoans));
